import * as React from "react";
const SvgSuccessTick = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#389C7B"
      fillRule="evenodd"
      d="M40 80C17.912 80 0 62.088 0 40S17.912 0 40 0s40 17.912 40 40-17.912 40-40 40m-5.503-32.962L58.5 23.035a2.145 2.145 0 0 1 3.016 0l2.722 2.721a2.153 2.153 0 0 1 0 3.017L36.047 56.965a2.14 2.14 0 0 1-1.876.589 2.1 2.1 0 0 1-1.234-.598L15.764 39.783a2.147 2.147 0 0 1 0-3.017l2.721-2.722c.831-.83 2.187-.83 3.017 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuccessTick;
